import React from 'react';
import { useState, useEffect, useCallback, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const css = `
.lab-wrap { display:flex; flex-direction:column; gap:12px; }
.lab-card  { background:var(--bg); border:0.5px solid var(--border); border-radius:10px; overflow:hidden; }
.lab-tabs  { display:flex; border-bottom:0.5px solid var(--border); overflow-x:auto; -webkit-overflow-scrolling:touch; scrollbar-width:none; }
.lab-tabs::-webkit-scrollbar { display:none; }
.lab-tab   { padding:9px 16px; font-size:12px; cursor:pointer; border-bottom:2px solid transparent;
             color:var(--text3); white-space:nowrap; }
.lab-tab.active { color:var(--navy-lt); border-bottom-color:var(--navy-lt); font-weight:500; }
.pac-bar   { display:flex; align-items:center; gap:12px; padding:10px 14px;
             background:var(--surface); border-bottom:0.5px solid var(--border); }
.pac-av    { width:34px; height:34px; border-radius:50%; background:var(--blue-lt); flex-shrink:0;
             display:flex; align-items:center; justify-content:center; font-size:12px;
             font-weight:500; color:var(--navy-lt); }
.pac-nom   { font-size:13px; font-weight:500; }
.pac-sub   { font-size:11px; color:var(--text3); }
.grp-grid  { display:grid; grid-template-columns:repeat(auto-fill,minmax(200px,1fr)); gap:10px;
             padding:14px; }
.grp-box   { border:0.5px solid var(--border); border-radius:8px; overflow:hidden; }
.grp-hdr   { background:var(--navy-lt); color:#fff; padding:6px 10px; font-size:10px; font-weight:600;
             text-transform:uppercase; letter-spacing:.4px; }
.grp-body  { padding:6px 8px; display:flex; flex-direction:column; gap:1px; }
.det-item  { display:flex; align-items:center; gap:7px; padding:3px 4px; font-size:11px;
             cursor:pointer; border-radius:4px; }
.det-item:hover { background:var(--surface); }
.det-item input { width:14px; height:14px; cursor:pointer; accent-color:var(--navy-lt); flex-shrink:0; }
.det-precio { font-size:10px; color:var(--text3); margin-left:auto; }
.lab-footer { padding:10px 14px; border-top:0.5px solid var(--border);
              display:flex; justify-content:space-between; align-items:center;
              background:var(--surface); flex-wrap:wrap; gap:8px; }
.sel-panel  { background:var(--surface); border-radius:8px; margin:0 14px 14px;
              padding:10px 12px; font-size:11px; }
.sel-tag    { display:inline-flex; align-items:center; gap:4px; background:var(--blue-lt); color:var(--navy-lt);
              padding:2px 8px; border-radius:20px; font-size:10px; margin:2px; }
.badge-cnt  { background:var(--navy-lt); color:#fff; font-size:10px; padding:1px 7px;
              border-radius:20px; font-weight:500; }
.hist-row   { display:flex; align-items:flex-start; gap:12px; padding:10px 14px;
              border-bottom:0.5px solid var(--border); }
.hist-row:last-child { border-bottom:none; }
.hist-row:hover { background:var(--surface); }
.b-act  { background:var(--blue-lt); color:var(--navy-lt); }
.b-cnf  { background:var(--green-lt); color:var(--green); }
.b-anl  { background:var(--red-lt); color:var(--red); }
.b-ext  { background:var(--amber-lt); color:var(--amber); }
.badge  { font-size:10px; padding:2px 8px; border-radius:20px; font-weight:500; }
.drop-zone { border:1.5px dashed var(--border); border-radius:8px; padding:24px; text-align:center;
             cursor:pointer; transition:border-color .2s; }
.drop-zone:hover,.drop-zone.over { border-color:var(--navy-lt); background:rgba(46,109,164,.08); }
.drop-zone .icon { font-size:28px; margin-bottom:6px; }
@media(max-width:600px){.grp-grid{grid-template-columns:1fr 1fr}}
.subdet-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:8px 10px}
.res-tbl-wrap{width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}
@media(max-width:640px){
  .subdet-grid{grid-template-columns:repeat(2,1fr)}
  .res-tbl th,.res-tbl td{padding:5px 6px;font-size:10px}
  .lab-tab{padding:9px 12px;font-size:11px}
  .muestra-grid{grid-template-columns:repeat(auto-fill,minmax(120px,1fr))}
  .pac-bar{padding:9px 12px;gap:9px}
  .lab-footer{padding:9px 12px}
}
.ord-card{border:1px solid var(--border);border-radius:9px;overflow:hidden;margin-bottom:10px}
.ord-hdr{display:flex;align-items:center;gap:10px;padding:10px 14px;background:var(--surface2);cursor:pointer;border-bottom:1px solid var(--border)}
.ord-hdr:hover{background:var(--blue-lt)}
.ord-num{font-size:12px;font-weight:700;color:var(--navy);font-family:monospace}
.muestra-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:7px;padding:10px 14px}
.muestra-card{border:1px solid var(--border);border-radius:7px;padding:8px 10px;display:flex;align-items:center;gap:7px;cursor:pointer;transition:all .12s}
.muestra-card:hover{border-color:var(--navy-lt);background:var(--blue-lt)}
.muestra-card.rec{border-color:var(--green);background:var(--green-lt)}
.tubo{width:18px;height:28px;border-radius:2px 2px 40% 40%;border:2px solid;display:flex;align-items:center;justify-content:center;font-size:7px;font-weight:700;flex-shrink:0;color:#fff}
.t-lila{background:#7c3aed;border-color:#7c3aed}
.t-rojo{background:#dc2626;border-color:#dc2626}
.t-azul{background:#2563eb;border-color:#2563eb}
.t-cafe{background:#92400e;border-color:#92400e}
.t-amar{background:#ca8a04;border-color:#ca8a04;color:#000}
.t-gris{background:#6b7280;border-color:#6b7280}
.etiq-card{background:var(--surface2);border:1px dashed var(--border);border-radius:7px;padding:8px 10px;display:flex;gap:9px;align-items:center}
.qr-box{width:38px;height:38px;background:var(--navy);border-radius:4px;display:flex;align-items:center;justify-content:center;color:#fff;font-size:8px;font-weight:700;flex-shrink:0}
.res-tbl{width:100%;border-collapse:collapse}
.res-tbl th{background:var(--navy);color:#fff;padding:5px 8px;font-size:9px;text-align:left}
.res-tbl td{padding:5px 8px;border-bottom:1px solid var(--bg);font-size:11px;vertical-align:middle}
.res-tbl tr:hover td{background:var(--surface2)}
.res-tbl tr.alt-row td{background:var(--red-lt)}
.res-sub-sep{background:var(--blue-lt);padding:3px 8px;font-size:9px;font-weight:700;color:var(--navy);text-transform:uppercase;letter-spacing:.4px;border-bottom:1px solid var(--border)}
.r-inp{border:0.5px solid var(--border);border-radius:5px;padding:3px 7px;font-size:11px;width:88px;background:var(--surface);color:var(--text);outline:none}
.r-inp:focus{border-color:var(--navy-lt)}
.r-inp.ok{border-color:var(--green);background:var(--green-lt)}
.r-inp.hi{border-color:var(--red);background:var(--red-lt)}
.r-inp.lo{border-color:var(--amber);background:var(--amber-lt)}
.rb-ok{background:var(--green-lt);color:var(--green);font-size:9px;padding:1px 7px;border-radius:4px;font-weight:600;white-space:nowrap}
.rb-hi{background:var(--red-lt);color:var(--red);font-size:9px;padding:1px 7px;border-radius:4px;font-weight:600;white-space:nowrap}
.rb-lo{background:var(--amber-lt);color:var(--amber);font-size:9px;padding:1px 7px;border-radius:4px;font-weight:600;white-space:nowrap}
.rb-na{background:var(--bg);color:var(--text3);font-size:9px;padding:1px 7px;border-radius:4px;white-space:nowrap}
.wa-btn{padding:5px 12px;border-radius:7px;border:none;background:#1a7a4a;color:#fff;font-size:11px;cursor:pointer;font-weight:500}
.wa-sent{padding:5px 12px;border-radius:7px;border:1px solid var(--green);background:var(--green-lt);color:var(--green);font-size:11px}
`;

const ESTADO = { ACT:{label:'Solicitado',cls:'b-act'}, CNF:{label:'Confirmado',cls:'b-cnf'},
                 ANL:{label:'Anulado',cls:'b-anl'}, EXT:{label:'Externo',cls:'b-ext'} };

export default function Laboratorio() {
  const [searchParams]   = useSearchParams();
  const { usuario }      = useAuth();
  const navigate         = useNavigate();
  const origenHistoria   = !!searchParams.get('paciente'); // vino desde Historia
  const [tab, setTab]    = useState('lab');
  const [paciente, setPac] = useState(null);
  const [busq, setBusq]  = useState('');
  const [sugs, setSugs]  = useState([]);

  // Laboratorio
  const [tiposLab, setTiposLab] = useState([]);
  const [tiposImg, setTiposImg] = useState([]);
  const [selIds, setSelIds]     = useState([]);
  const [baterias, setBaterias] = useState([]); // paquetes/paneles predefinidos (ej. "Perfil Lipídico")
  const [gruposAbiertos, setGruposAbiertos] = useState({});
  const toggleGrupo = key => setGruposAbiertos(g => ({...g, [key]: !g[key]}));
  const [observ, setObserv]     = useState('');
  const [saving, setSaving]     = useState(false);
  const [historial, setHistorial] = useState([]);
  const [loadingH, setLoadingH]   = useState(false);
  const [editando, setEditando]     = useState(null);
  const [selIdsEdit, setSelIdsEdit] = useState([]);
  const [observEdit, setObservEdit] = useState('');
  const [savingEdit, setSavingEdit] = useState(false);

  // Resultados / Validación
  const [ordenes,    setOrdenes]   = useState([]);
  const [loadingOrd, setLoadingOrd]= useState(false);
  const [ordExp,     setOrdExp]    = useState(null);
  const [muestrasOrd,setMuestrasOrd]=useState({});
  const [rangosOrd,  setRangosOrd] = useState(null);
  const [resultados, setResultados]= useState({});
  const [obsOrd,     setObsOrd]    = useState({recibo:'',laboratorista:'',resultados_obs:''});
  const [savingOrd,  setSavingOrd] = useState(false);
  const [waInfo,     setWaInfo]    = useState(null);
  // Archivos
  const [dragging, setDragging] = useState(false);
  const [archivos, setArchivos] = useState([]);

  const cargarArchivos = useCallback(async () => {
    if (!paciente) return;
    try {
      const { data } = await api.get(`/laboratorio/archivos-paciente?cod_paciente=${paciente.COD}`);
      setArchivos(data);
    } catch { setArchivos([]); }
  }, [paciente]);
  const [descArch, setDescArch] = useState('');
  const fileRef = useRef();

  const cargarTipos = useCallback(async () => {
    const [rLab, rImg] = await Promise.all([
      api.get('/laboratorio/tipos?formulario=CLN'),
      api.get('/laboratorio/tipos?formulario=IMG'),
    ]);
    setTiposLab(rLab.data);
    setTiposImg(rImg.data);
  }, []);

  useEffect(() => { cargarTipos(); }, [cargarTipos]);

  useEffect(() => {
    api.get('/laboratorio/baterias').then(r => setBaterias(r.data||[])).catch(() => setBaterias([]));
  }, []);

  // Un paquete se considera "activo" cuando TODOS sus exámenes ya están
  // seleccionados. Un clic alterna: si está activo lo desactiva (quita esos
  // exámenes de la selección), si no lo está lo activa (los agrega todos,
  // sin duplicar). El médico igual puede desmarcar uno suelto desde
  // "Seleccionados" sin que eso rompa el resto del paquete.
  const paqueteActivo = (bat) => bat.examenes.length > 0 && bat.examenes.every(e => selIds.includes(e.COD));

  const togglePaquete = (bat) => {
    const idsPaquete = bat.examenes.map(e => e.COD);
    if (paqueteActivo(bat)) {
      setSelIds(s => s.filter(id => !idsPaquete.includes(id)));
    } else {
      setSelIds(s => Array.from(new Set([...s, ...idsPaquete])));
    }
  };

  const renderPaquetes = () => (
    baterias.length > 0 && (
      <div style={{padding:'12px 14px 0'}}>
        <div style={{fontSize:10,color:'var(--text3)',marginBottom:6,fontWeight:600,
          textTransform:'uppercase',letterSpacing:'.4px'}}>📦 Paquetes rápidos</div>
        <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
          {baterias.map(bat => {
            const activo = paqueteActivo(bat);
            return (
              <button key={bat.COD} type="button" className="btn btn-sm"
                style={activo
                  ? {fontSize:11,padding:'4px 10px',background:'var(--navy-lt)',color:'#fff',border:'1px solid var(--navy-lt)'}
                  : {fontSize:11,padding:'4px 10px',background:'var(--blue-lt)',color:'var(--navy-lt)',border:'1px solid var(--navy-lt)'}}
                onClick={() => togglePaquete(bat)}>
                {activo ? '✓' : '+'} {bat.NOMBRE_BATERIA} <span style={{opacity:.7}}>({bat.examenes.length})</span>
              </button>
            );
          })}
        </div>
      </div>
    )
  );

  useEffect(() => {
    const cod = searchParams.get('paciente');
    if (cod) api.get(`/pacientes/${cod}`).then(r => setPac(r.data)).catch(() => {});
  }, [searchParams]);

  useEffect(() => {
    if (busq.length < 2) { setSugs([]); return; }
    api.get(`/pacientes?q=${encodeURIComponent(busq)}&limit=6`)
      .then(r => setSugs(r.data)).catch(() => {});
  }, [busq]);

  /* ══ RESULTADOS ══ */
  const cargarOrdenes = async () => {
    if (!paciente?.COD) return;
    setLoadingOrd(true);
    try {
      const {data} = await api.get('/laboratorio/solicitudes?cod_paciente='+paciente.COD);
      setOrdenes((data||[]).filter(s=>s.C_ESTADO==='ACT'));
    } catch(_){}
    setLoadingOrd(false);
  };

  const expandirOrden = async cod => {
    if (ordExp===cod){setOrdExp(null);return;}
    setOrdExp(cod); setRangosOrd(null); setResultados({}); setWaInfo(null);
    setObsOrd({recibo:'',laboratorista:'',resultados_obs:''});
    try {
      const {data} = await api.get('/laboratorio/solicitudes/'+cod+'/rangos');
      setRangosOrd(data);
      const vals={};
      (data.detalles||[]).forEach(d=>{
        if(d.RESULTADO)vals[d.COD]=d.RESULTADO;
        (d.subdeterminaciones||[]).forEach(s=>{ if(s.RESULTADO) vals[`${d.COD}_${s.COD}`]=s.RESULTADO; });
      });
      setResultados(vals);
    } catch(e){console.error(e);}
    try {
      const {data:ms} = await api.get('/laboratorio/solicitudes/'+cod+'/muestras');
      setMuestrasOrd(m=>({...m,[cod]:ms}));
    } catch(_){setMuestrasOrd(m=>({...m,[cod]:[]}));}
  };

  const toggleMuestra = async (codOrden, codTipoMuestra) => {
    const lista = muestrasOrd[codOrden]||[];
    const actual = lista.find(m=>m.COD_TIPO_MUESTRA===codTipoMuestra);
    const nuevoEst = actual?.C_ESTADO==='REC'?'PEN':'REC';
    try {
      await api.post('/laboratorio/solicitudes/'+codOrden+'/muestras',{
        cod_tipo_muestra: codTipoMuestra, estado: nuevoEst, usuario: usuario?.usuario
      });
      const {data:ms} = await api.get('/laboratorio/solicitudes/'+codOrden+'/muestras');
      setMuestrasOrd(m=>({...m,[codOrden]:ms}));
    } catch(e){console.error(e);}
  };

  const subirArchivoResultado = async (codOrden, codDetalle, file) => {
    const fd = new FormData();
    fd.append('archivo', file);
    fd.append('cod_detalle', codDetalle);
    fd.append('usuario', usuario?.usuario||'');
    try {
      const {data} = await api.post('/laboratorio/solicitudes/'+codOrden+'/archivo', fd, { headers:{'Content-Type':'multipart/form-data'} });
      setRangosOrd(r=>!r?r:{...r, detalles:r.detalles.map(d=>d.COD===codDetalle?{...d, ARCHIVO_RESULTADO:data.archivo}:d)});
      setResultados(r=>({...r, [codDetalle]: 'Archivo adjunto: '+file.name}));
    } catch(e){ alert('Error al subir archivo: '+(e.response?.data?.error||e.message)); }
  };

  const evalR = (v,rango) => {
    if(!rango||!v) return 'na';
    const n=parseFloat(v); if(isNaN(n)) return 'na';
    const li=parseFloat(rango.LIMITE_INFERIOR),ls=parseFloat(rango.LIMITE_SUPERIOR);
    if(ls>0&&n>ls) return 'hi'; if(li>0&&n<li) return 'lo'; return 'ok';
  };

  const guardarBorradorOrd = async cod => {
    setSavingOrd(true);
    try {
      const payload=Object.entries(resultados).map(([k,v])=>{
        const p=k.split('_');
        return p.length===2 ? {cod_detalle:parseInt(p[0]),cod_sub:parseInt(p[1]),resultado:v} : {cod_detalle:parseInt(k),resultado:v};
      });
      await api.put('/laboratorio/solicitudes/'+cod+'/borrador',{resultados:payload});
      alert('Borrador guardado');
    } catch(e){alert('Error: '+e.message);}
    setSavingOrd(false);
  };

  const validarOrden = async cod => {
    if(!Object.keys(resultados).length){alert('Ingresa al menos un resultado');return;}
    setSavingOrd(true);
    try {
      const payload=Object.entries(resultados).map(([k,v])=>{
        const p=k.split('_');
        return p.length===2 ? {cod_detalle:parseInt(p[0]),cod_sub:parseInt(p[1]),resultado:v} : {cod_detalle:parseInt(k),resultado:v};
      });
      await api.put('/laboratorio/solicitudes/'+cod+'/resultado',{resultados:payload,usuario:usuario?.usuario});
      const {data} = await api.put('/laboratorio/solicitudes/'+cod+'/validar',{
        OBS_RECIBO:obsOrd.recibo, OBS_LABORATORISTA:obsOrd.laboratorista, OBS_RESULTADOS:obsOrd.resultados_obs,
      });
      setWaInfo(data); setOrdenes(s=>s.filter(x=>x.COD!==cod)); setOrdExp(null);
    } catch(e){alert('Error: '+e.message);}
    setSavingOrd(false);
  };

  const TUBOS_MAP = {
    1:{cls:'t-lila',l:'S'},2:{cls:'t-rojo',l:'S'},3:{cls:'t-azul',l:'P'},
    4:{cls:'t-amar',l:'O'},5:{cls:'t-cafe',l:'H'},6:{cls:'t-gris',l:'Se'},
    7:{cls:'t-gris',l:'Es'},8:{cls:'t-verde',l:'L'},
  };

  const cargarHistorial = useCallback(async () => {
    if (!paciente?.COD) return;
    setLoadingH(true);
    try {
      const { data } = await api.get(`/laboratorio/solicitudes?cod_paciente=${paciente.COD}`);
      setHistorial(data);
    } catch {}
    setLoadingH(false);
  }, [paciente]);

  useEffect(() => { if (paciente) cargarHistorial(); }, [paciente, cargarHistorial]);

  useEffect(() => {
    const codEditar = searchParams.get('editar');
    if (!codEditar || !historial.length) return;
    const sol = historial.find(h => String(h.COD) === codEditar);
    if (sol) abrirEdicion(sol);
  }, [historial, searchParams]);
  useEffect(() => { if (paciente && tab === 'archivos') cargarArchivos(); }, [paciente, tab, cargarArchivos]);

  useEffect(() => {
    if (tab==='resultados' && paciente) cargarOrdenes();
  }, [tab, paciente]);

  const toggleDet = (cod) => setSelIds(s => s.includes(cod) ? s.filter(x=>x!==cod) : [...s,cod]);

  const allDets = [...tiposLab, ...tiposImg].flatMap(t => t.determinaciones||[]);
  const selDets = allDets.filter(d => selIds.includes(d.COD));

  const descargarPedidoPDF = async (ids) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${process.env.REACT_APP_API_URL||'http://localhost:3001/api'}/laboratorio/pedido-pdf`,
        { method:'POST',
          headers:{ Authorization:`Bearer ${token}`, 'Content-Type':'application/json' },
          body: JSON.stringify({ ids }) }
      );
      const blob = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Pedido_Lab_${ids[0]}.pdf`;
      a.click();
    } catch(e) { alert('Error al generar PDF: ' + e.message); }
  };

  const descargarEtiquetas = async (codSolicitud) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${process.env.REACT_APP_API_URL||'http://localhost:3001/api'}/laboratorio/solicitudes/${codSolicitud}/etiquetas-pdf`,
        { method:'POST', headers:{ Authorization:`Bearer ${token}` } }
      );
      if (!res.ok) {
        const err = await res.json().catch(()=>({}));
        alert(err.error || 'Error al generar etiquetas');
        return;
      }
      const blob = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Etiquetas_Lab_${codSolicitud}.pdf`;
      a.click();
    } catch(e) { alert('Error: ' + e.message); }
  };

  const descargarInforme = async (codSolicitud) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${process.env.REACT_APP_API_URL||'http://localhost:3001/api'}/laboratorio/solicitudes/${codSolicitud}/informe-pdf`,
        { method:'POST', headers:{ Authorization:`Bearer ${token}` } }
      );
      if (!res.ok) { alert('Error al generar informe'); return; }
      const blob = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Informe_Lab_${codSolicitud}.pdf`;
      a.click();
    } catch(e) { alert('Error: ' + e.message); }
  };

  const descargarPDF = async (codSolicitud) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `${process.env.REACT_APP_API_URL||'http://localhost:3001/api'}/laboratorio/solicitudes/${codSolicitud}/pdf`,
        { method:'POST', headers:{ Authorization:`Bearer ${token}` } }
      );
      const blob = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Pedido_Lab_${codSolicitud}.pdf`;
      a.click();
    } catch(e) { alert('Error al generar PDF: ' + e.message); }
  };

  const anularSolicitud = async (codSolicitud) => {
    if (!window.confirm('¿Anular este pedido de laboratorio? Esta acción no se puede deshacer.')) return;
    try {
      await api.delete(`/laboratorio/solicitudes/${codSolicitud}`);
      await cargarHistorial();
    } catch(e) { alert(e.response?.data?.error || e.message); }
  };

  const abrirEdicion = (h) => {
    setEditando(h);
    setSelIdsEdit((h.detalles||[]).map(d => d.COD_DETERMINACION));
    setObservEdit(h.DATOS_CLINICOS || '');
  };

  const toggleDetEdit = (id) => {
    setSelIdsEdit(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const guardarEdicion = async () => {
    if (!selIdsEdit.length) { alert('Debe mantener al menos un examen en el pedido'); return; }
    setSavingEdit(true);
    try {
      await api.put(`/laboratorio/solicitudes/${editando.COD}`, {
        datos_clinicos: observEdit,
        determinaciones: selIdsEdit,
        usuario: usuario?.usuario,
      });
      setEditando(null);
      await cargarHistorial();
    } catch(e) { alert(e.response?.data?.error || e.message); }
    setSavingEdit(false);
  };

  const guardarSolicitud = async () => {
    if (!paciente) { alert('Selecciona un paciente'); return; }
    if (!selIds.length) { alert('Selecciona al menos un examen'); return; }
    setSaving(true);
    try {
      // Agrupar exámenes seleccionados por tipo — una orden por grupo
      const todosLos = [...tiposLab, ...tiposImg].flatMap(t =>
        (t.determinaciones||[]).map(d => ({...d, COD_TIPO: t.COD, TIPO_NOM: t.TIPO_DETERMINACION}))
      );
      const grupos = {};
      selIds.forEach(id => {
        const det = todosLos.find(d => d.COD === id);
        if (!det) return;
        if (!grupos[det.COD_TIPO]) grupos[det.COD_TIPO] = { tipo: det.COD_TIPO, nombre: det.TIPO_NOM, dets: [] };
        grupos[det.COD_TIPO].dets.push(id);
      });

      const ordenes = Object.values(grupos);
      const codsPDF = [];
      for (const grp of ordenes) {
        const resp = await api.post('/laboratorio/solicitudes', {
          cod_paciente:    paciente.COD,
          cod_tipo_examen: grp.tipo,
          datos_clinicos:  observ,
          determinaciones: grp.dets,
          usuario:         usuario?.usuario,
        });
        codsPDF.push(resp.data.COD);
      }

      setSelIds([]); setObserv('');
      await cargarHistorial();
      // Un solo PDF con todas las órdenes
      if (codsPDF.length > 0) await descargarPedidoPDF(codsPDF);
    } catch(e) { alert(e.response?.data?.error || e.message); }
    setSaving(false);
  };

  const subirArchivo = async (file) => {
    if (!paciente) { alert('Selecciona un paciente'); return; }
    const fd = new FormData();
    fd.append('archivo', file);
    fd.append('cod_paciente', paciente.COD);
    fd.append('descripcion', descArch || file.name);
    fd.append('usuario', usuario?.usuario);
    try {
      await api.post('/laboratorio/archivos-paciente', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      await cargarArchivos();
      cargarHistorial();
    } catch(e) { alert(e.response?.data?.error || e.message); }
  };

  const renderGrupos = (tipos) => (
    <div className="grp-grid">
      {tipos.flatMap(tipo => {
        const dets = tipo.determinaciones||[];
        const simples      = dets.filter(d => /\bsimple\b/i.test(d.DETERMINACION));
        const contrastadas = dets.filter(d => /\bcontrastad/i.test(d.DETERMINACION));
        const otras        = dets.filter(d => !/\bsimple\b/i.test(d.DETERMINACION) && !/\bcontrastad/i.test(d.DETERMINACION));
        const separar = simples.length > 0 && contrastadas.length > 0;

        const itemRow = d => (
          <label key={d.COD} className="det-item">
            <input type="checkbox" checked={selIds.includes(d.COD)}
              onChange={() => toggleDet(d.COD)}/>
            {d.DETERMINACION}
            {d.PRECIO > 0 && <span className="det-precio">${Number(d.PRECIO).toFixed(2)}</span>}
          </label>
        );

        const contarSel = items => items.filter(d => selIds.includes(d.COD)).length;

        const caja = (key, titulo, items) => {
          const abierto = !!gruposAbiertos[key];
          const nsel = contarSel(items);
          return (
            <div key={key} className="grp-box">
              <div className="grp-hdr" style={{cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'space-between'}}
                onClick={()=>toggleGrupo(key)}>
                <span>{titulo}{nsel>0&&<span style={{marginLeft:8,fontSize:11,opacity:.85}}>({nsel} seleccionado{nsel>1?'s':''})</span>}</span>
                <span style={{fontSize:12}}>{abierto?'▾':'▸'}</span>
              </div>
              {abierto&&<div className="grp-body">{items.map(itemRow)}</div>}
            </div>
          );
        };

        if (!separar) {
          return [caja(tipo.COD, tipo.TIPO_DETERMINACION, dets)];
        }

        const cajas = [
          caja(`${tipo.COD}-simples`, `${tipo.TIPO_DETERMINACION} — Simples`, simples),
          caja(`${tipo.COD}-contrastadas`, `${tipo.TIPO_DETERMINACION} — Contrastadas`, contrastadas),
        ];
        if (otras.length > 0) {
          cajas.push(caja(`${tipo.COD}-otras`, `${tipo.TIPO_DETERMINACION} — Otras`, otras));
        }
        return cajas;
      })}
    </div>
  );

  const nombre = paciente
    ? [paciente.APELLIDO_PATERNO, paciente.APELLIDO_MATERNO, paciente.PRIMER_NOMBRE].filter(Boolean).join(' ')
    : '';
  const iniciales = nombre ? nombre.split(' ').slice(0,2).map(w=>w[0]).join('') : '??';

  return (
    <>
      <style>{css}</style>
      <div className="lab-wrap fade-up">

        {/* Buscador paciente */}
        <div className="lab-card">
          <div className="pac-bar">
            {paciente ? (
              <>
                <div className="pac-av">{iniciales}</div>
                <div>
                  <div className="pac-nom">{nombre}</div>
                  <div className="pac-sub">CI: {paciente.IDENTIFICACION} · {paciente.EDAD||''}</div>
                </div>
                <div style={{marginLeft:'auto',display:'flex',gap:6}}>
                  {origenHistoria && (
                    <button className="btn btn-primary btn-sm"
                      onClick={() => navigate(`/historia?paciente=${paciente.COD}`)}>
                      ← Volver a Historia
                    </button>
                  )}
                  <button className="btn btn-sm"
                    onClick={() => { setPac(null); setHistorial([]); }}>
                    Cambiar paciente
                  </button>
                </div>
              </>
            ) : (
              <div style={{flex:1,position:'relative'}}>
                <input className="form-control" placeholder="Buscar paciente por nombre o cédula..."
                  value={busq} onChange={e => setBusq(e.target.value)}
                  style={{fontSize:13}}/>
                {sugs.length > 0 && (
                  <div style={{position:'absolute',top:'100%',left:0,right:0,background:'var(--bg)',
                    border:'0.5px solid var(--border)',borderRadius:8,zIndex:50,overflow:'hidden',marginTop:4}}>
                    {sugs.map(p => (
                      <div key={p.COD} style={{padding:'8px 12px',cursor:'pointer',fontSize:12,
                        borderBottom:'0.5px solid var(--border)'}}
                        onClick={() => { setPac(p); setBusq(''); setSugs([]); }}
                        onMouseEnter={e=>e.target.style.background='var(--surface)'}
                        onMouseLeave={e=>e.target.style.background=''}>
                        <strong>{[p.APELLIDO_PATERNO,p.APELLIDO_MATERNO,p.PRIMER_NOMBRE].filter(Boolean).join(' ')}</strong>
                        <span style={{color:'var(--text3)',marginLeft:8}}>{p.IDENTIFICACION}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Pestañas */}
          <div className="lab-tabs">
            {[['lab','🧪 Laboratorio clínico'],['img','🔬 Imagenología'],
              ['resultados','📥 Resultados'],['hist','📋 Historial'],['arch','📁 Archivos del paciente']].map(([k,l]) => (
              <div key={k} className={`lab-tab ${tab===k?'active':''}`}
                onClick={() => setTab(k)}>{l}</div>
            ))}
          </div>

          {/* ── Laboratorio clínico ── */}
          {tab==='lab' && (<>
            {renderPaquetes()}
            {renderGrupos(tiposLab)}
            {selDets.filter(d=>tiposLab.flatMap(t=>t.determinaciones||[]).find(x=>x.COD===d.COD)).length > 0 && (
              <div className="sel-panel">
                <div style={{fontWeight:500,fontSize:11,marginBottom:6}}>
                  Seleccionados <span className="badge-cnt">
                    {selDets.filter(d=>tiposLab.flatMap(t=>t.determinaciones||[]).find(x=>x.COD===d.COD)).length}
                  </span>
                </div>
                {selDets.filter(d=>tiposLab.flatMap(t=>t.determinaciones||[]).find(x=>x.COD===d.COD)).map(d => (
                  <span key={d.COD} className="sel-tag">
                    {d.DETERMINACION}
                    <span style={{cursor:'pointer',fontWeight:500}} onClick={()=>toggleDet(d.COD)}>×</span>
                  </span>
                ))}
                <div style={{marginTop:8}}>
                  <textarea className="form-control" placeholder="Indicaciones clínicas..." rows={2}
                    value={observ} onChange={e=>setObserv(e.target.value)}
                    style={{fontSize:11,resize:'vertical'}}/>
                </div>
              </div>
            )}
            <div className="lab-footer">
              <div style={{fontSize:11,color:'var(--text3)'}}>
                Dr. {usuario?.nombres} · {new Date().toLocaleDateString('es-EC')}
              </div>
              <div style={{display:'flex',gap:8}}>
                <button className="btn btn-sm" onClick={()=>setSelIds([])}>Limpiar</button>
                <button className="btn btn-primary" disabled={saving||!selIds.length}
                  onClick={guardarSolicitud}>
                  {saving?'Guardando...':'✓ Generar solicitud'}
                </button>
              </div>
            </div>
          </>)}

          {/* ── Imagenología ── */}
          {tab==='img' && (<>
            {renderPaquetes()}
            {renderGrupos(tiposImg)}
            {selDets.filter(d=>tiposImg.flatMap(t=>t.determinaciones||[]).find(x=>x.COD===d.COD)).length > 0 && (
              <div className="sel-panel">
                <div style={{fontWeight:500,fontSize:11,marginBottom:6}}>
                  Seleccionados <span className="badge-cnt">
                    {selDets.filter(d=>tiposImg.flatMap(t=>t.determinaciones||[]).find(x=>x.COD===d.COD)).length}
                  </span>
                </div>
                {selDets.filter(d=>tiposImg.flatMap(t=>t.determinaciones||[]).find(x=>x.COD===d.COD)).map(d => (
                  <span key={d.COD} className="sel-tag">
                    {d.DETERMINACION}
                    <span style={{cursor:'pointer',fontWeight:500}} onClick={()=>toggleDet(d.COD)}>×</span>
                  </span>
                ))}
                <div style={{marginTop:8}}>
                  <textarea className="form-control" placeholder="Indicaciones clínicas..." rows={2}
                    value={observ} onChange={e=>setObserv(e.target.value)}
                    style={{fontSize:11,resize:'vertical'}}/>
                </div>
              </div>
            )}
            <div className="lab-footer">
              <div style={{fontSize:11,color:'var(--text3)'}}>
                Dr. {usuario?.nombres} · {new Date().toLocaleDateString('es-EC')}
              </div>
              <div style={{display:'flex',gap:8}}>
                <button className="btn btn-sm" onClick={()=>setSelIds([])}>Limpiar</button>
                <button className="btn btn-primary" disabled={saving||!selIds.length}
                  onClick={guardarSolicitud}>
                  {saving?'Guardando...':'✓ Generar solicitud'}
                </button>
              </div>
            </div>
          </>)}

          {/* ── Historial ── */}
          {tab==='hist' && (
            <div>
              {!paciente && <div style={{padding:32,textAlign:'center',color:'var(--text3)'}}>Selecciona un paciente para ver el historial</div>}
              {loadingH && <div style={{padding:24,textAlign:'center',color:'var(--text3)'}}>Cargando...</div>}
              {!loadingH && paciente && historial.length===0 && (
                <div style={{padding:32,textAlign:'center',color:'var(--text3)'}}>Sin solicitudes previas</div>
              )}
              {historial.map(h => (
                <div key={h.COD} className="hist-row">
                  <div style={{flex:1}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                      <span style={{fontSize:12,fontWeight:500}}>{h.TIPO_DETERMINACION}</span>
                      <span className={`badge ${ESTADO[h.C_ESTADO]?.cls||'b-act'}`}>
                        {ESTADO[h.C_ESTADO]?.label||h.C_ESTADO}
                      </span>
                      <span style={{fontSize:11,color:'var(--text3)',marginLeft:'auto',display:'flex',alignItems:'center',gap:8}}>
                        {h.FECHA_SOLICITUD} · {h.MEDICO_SOLICITA}
                        {h.C_ESTADO!=='ANL'&&(
                          <>
                            {h.C_ESTADO==='CNF'&&<button className="btn btn-sm" style={{fontSize:10,padding:'2px 8px',background:'var(--blue-lt)',color:'var(--navy)',border:'1px solid var(--navy-lt)',marginRight:4}}
                              onClick={()=>descargarInforme(h.COD)}>📋 Informe</button>}
                            <button className="btn btn-sm" style={{fontSize:10,padding:'2px 8px'}}
                              onClick={()=>descargarPDF(h.COD)}>
                              🖨 PDF
                            </button>
                            {['MEDICO','ADMINISTRADOR'].includes(usuario?.tipo_usuario) && !(h.detalles||[]).some(d=>d.RESULTADO) && (
                              <>
                                <button className="btn btn-sm" style={{fontSize:10,padding:'2px 8px',marginLeft:4}}
                                  onClick={()=>abrirEdicion(h)}>
                                  ✎ Editar
                                </button>
                                <button className="btn btn-sm" style={{fontSize:10,padding:'2px 8px',background:'var(--red-lt,#fdecea)',color:'var(--red,#c0392b)',border:'1px solid var(--red,#c0392b)',marginLeft:4}}
                                  onClick={()=>anularSolicitud(h.COD)}>
                                  ✕ Anular
                                </button>
                              </>
                            )}
                          </>
                        )}
                      </span>
                    </div>
                    <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
                      {(h.detalles||[]).map(d => (
                        <span key={d.COD} style={{fontSize:10,padding:'1px 7px',borderRadius:4,
                          background:'var(--surface)',color:'var(--text2)'}}>
                          {d.DETERMINACION}
                          {d.RESULTADO && <span style={{color:'var(--green)',marginLeft:4}}>✓</span>}
                        </span>
                      ))}
                    </div>
                    {h.DATOS_CLINICOS && !h.DATOS_CLINICOS.includes('ARCHIVO:') && (
                      <div style={{fontSize:11,color:'var(--text3)',marginTop:4}}>{h.DATOS_CLINICOS}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* ── Resultados / Validación ── */}
          {tab==='resultados'&&(
            <div style={{padding:14,display:'flex',flexDirection:'column',gap:0}}>
              {!paciente&&<div style={{padding:32,textAlign:'center',color:'var(--text3)'}}>Selecciona un paciente para ver las órdenes</div>}
              {paciente&&loadingOrd&&<div style={{padding:24,textAlign:'center',color:'var(--text3)'}}>Cargando...</div>}
              {paciente&&!loadingOrd&&ordenes.length===0&&<div style={{padding:32,textAlign:'center',color:'var(--text3)'}}><div style={{fontSize:24,marginBottom:8}}>✅</div>No hay órdenes pendientes de resultado</div>}
              {waInfo&&(
                <div style={{background:'var(--green-lt)',border:'1px solid var(--green)',borderRadius:9,padding:'12px 14px',marginBottom:12,display:'flex',alignItems:'center',gap:10}}>
                  <span style={{fontSize:20}}>✅</span>
                  <div style={{flex:1}}>
                    <div style={{fontSize:12,fontWeight:600,color:'var(--green)'}}>Resultados validados correctamente</div>
                    <div style={{fontSize:11,color:'var(--text3)'}}>Token generado · Link listo para enviar al paciente</div>
                  </div>
                  <button className="wa-btn" onClick={()=>window.open(waInfo.whatsapp_url,'_blank')}>📱 Enviar por WhatsApp</button>
                </div>
              )}
              {paciente&&ordenes.map(ord=>(
                <div key={ord.COD} className="ord-card">
                  {/* Header de la orden */}
                  <div className="ord-hdr" onClick={()=>expandirOrden(ord.COD)}>
                    <span className="ord-num">LAB-{String(ord.COD).padStart(5,'0')}</span>
                    <div style={{flex:1}}>
                      <div style={{fontSize:12,fontWeight:600,color:'var(--text)'}}>{ord.TIPO_DETERMINACION}</div>
                      <div style={{fontSize:10,color:'var(--text3)'}}>{ord.FECHA_SOLICITUD} · {ord.MEDICO_SOLICITA}</div>
                    </div>
                    <span className="badge b-act" style={{fontSize:9}}>⏳ Pendiente</span>
                    <span style={{fontSize:11,color:'var(--text3)',marginLeft:6}}>{ordExp===ord.COD?'▲':'▼'}</span>
                  </div>

                  {ordExp===ord.COD&&(
                    <>
                      {/* PASO 1: Muestras */}
                      <div style={{borderBottom:'1px solid var(--border)'}}>
                        <div style={{background:'var(--navy)',padding:'5px 12px',display:'flex',alignItems:'center',gap:7}}>
                          <div style={{width:18,height:18,borderRadius:'50%',background:'rgba(255,255,255,.25)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:700}}>1</div>
                          <span style={{fontSize:10,fontWeight:600,color:'#fff'}}>Recepción de muestras</span>
                          <span style={{fontSize:9,color:'rgba(255,255,255,.5)',marginLeft:4}}>Confirma las muestras recibidas</span>
                        </div>
                        <div className="muestra-grid">
                          {(muestrasOrd[ord.COD]||[]).length===0&&<div style={{padding:8,fontSize:11,color:'var(--text3)',gridColumn:'1/-1'}}>Cargando muestras...</div>}
                          {(muestrasOrd[ord.COD]||[]).map(m=>{
                            const tb=TUBOS_MAP[m.COD_TIPO_MUESTRA]||{cls:'t-gris',l:'?'};
                            return(
                              <div key={m.COD_TIPO_MUESTRA} className={'muestra-card'+(m.C_ESTADO==='REC'?' rec':'')}
                                onClick={()=>toggleMuestra(ord.COD,m.COD_TIPO_MUESTRA)}>
                                <div className={'tubo '+tb.cls}>{tb.l}</div>
                                <div>
                                  <div style={{fontSize:10,fontWeight:500,color:'var(--text)'}}>{m.MUESTRA}</div>
                                  <div style={{fontSize:9,color:m.C_ESTADO==='REC'?'var(--green)':'var(--text3)'}}>
                                    {m.C_ESTADO==='REC'?'✓ Recibida':'⏳ Pendiente'}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      {/* PASO 2: Etiquetas */}
                      <div style={{borderBottom:'1px solid var(--border)',padding:'0 0 10px'}}>
                        <div style={{background:'var(--navy)',padding:'5px 12px',display:'flex',alignItems:'center',gap:7,marginBottom:8}}>
                          <div style={{width:18,height:18,borderRadius:'50%',background:'rgba(255,255,255,.25)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:700}}>2</div>
                          <span style={{fontSize:10,fontWeight:600,color:'#fff'}}>Etiquetas para tubos</span>
                          <button style={{marginLeft:'auto',padding:'2px 9px',borderRadius:5,border:'none',background:'rgba(255,255,255,.2)',color:'#fff',fontSize:9,cursor:'pointer'}}
                            onClick={e=>{e.stopPropagation();descargarEtiquetas(ord.COD);}}>🖨️ Imprimir</button>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',gap:6,padding:'0 12px'}}>
                          {(muestrasOrd[ord.COD]||[]).filter(m=>m.C_ESTADO==='REC').map((m,i)=>(
                            <div key={i} className="etiq-card">
                              <div className="qr-box">QR</div>
                              <div>
                                <div style={{fontSize:10,fontWeight:600,color:'var(--text)'}}>LAB-{String(ord.COD).padStart(5,'0')}-M{i+1}</div>
                                <div style={{fontSize:9,color:'var(--text3)'}}>{[paciente?.APELLIDO_PATERNO,paciente?.PRIMER_NOMBRE].filter(Boolean).join(' ')} · {m.MUESTRA}</div>
                                <div style={{fontSize:9,color:'var(--text3)'}}>{ord.FECHA_SOLICITUD} · {ord.TIPO_DETERMINACION}</div>
                              </div>
                            </div>
                          ))}
                          {(muestrasOrd[ord.COD]||[]).filter(m=>m.C_ESTADO==='REC').length===0&&(
                            <div style={{fontSize:11,color:'var(--text3)',padding:'4px 0'}}>Confirma las muestras recibidas para generar etiquetas</div>
                          )}
                        </div>
                      </div>

                      {/* PASO 3: Resultados */}
                      <div style={{borderBottom:'1px solid var(--border)'}}>
                        <div style={{background:'var(--navy)',padding:'5px 12px',display:'flex',alignItems:'center',gap:7}}>
                          <div style={{width:18,height:18,borderRadius:'50%',background:'rgba(255,255,255,.25)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:700}}>3</div>
                          <span style={{fontSize:10,fontWeight:600,color:'#fff'}}>Ingreso de resultados</span>
                          {Object.values(resultados).filter(v=>v).length>0&&(
                            <span style={{marginLeft:'auto',background:'var(--amber-lt)',color:'var(--amber)',fontSize:9,padding:'1px 7px',borderRadius:4,fontWeight:600}}>
                              {Object.values(resultados).filter(v=>v).length} valor(es)
                            </span>
                          )}
                        </div>
                        {!rangosOrd&&<div style={{padding:20,textAlign:'center',color:'var(--text3)'}}>Cargando determinaciones...</div>}
                        {rangosOrd&&(()=>{
                          /* ── Helper: input según tipo de resultado POR DETERMINACIÓN ── */
                          const findCategoria = (val, categorias) => {
                            if (!val || !categorias?.length) return null;
                            const v = parseFloat(val);
                            if (isNaN(v)) return null;
                            return categorias.find(c => v >= parseFloat(c.LIMITE_INFERIOR) && v <= parseFloat(c.LIMITE_SUPERIOR));
                          };

                          const renderCategoriaChain = (val, categorias) => {
                            if (!categorias?.length) return null;
                            const actual = findCategoria(val, categorias);
                            return (
                              <div style={{display:'flex',flexWrap:'wrap',gap:4,alignItems:'center',marginTop:4}}>
                                {categorias.map((c,i)=>{
                                  const isCurrent = actual && c.ORDEN===actual.ORDEN;
                                  return (
                                    <span key={i} style={{
                                      fontSize:9.5, padding:'2px 7px', borderRadius:10,
                                      background:c.COLOR+'22', color:c.COLOR,
                                      fontWeight:isCurrent?700:400,
                                      border:isCurrent?`1.5px solid ${c.COLOR}`:'1px solid transparent'
                                    }}>
                                      {c.LIMITE_INFERIOR}-{c.LIMITE_SUPERIOR>=999?'+':c.LIMITE_SUPERIOR} {c.ETIQUETA}
                                    </span>
                                  );
                                })}
                              </div>
                            );
                          };

                          const renderOpcionesPills = (key, val, categorias) => {
                            if (!categorias?.length) return null;
                            return (
                              <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
                                {categorias.map((c,i)=>{
                                  const isSel = val===c.ETIQUETA;
                                  return (
                                    <button key={i} onClick={()=>setResultados(r=>({...r,[key]:c.ETIQUETA}))}
                                      style={{padding:'3px 10px',borderRadius:5,fontSize:10,cursor:'pointer',
                                        border:isSel?'1.5px solid #111':`1px solid ${c.COLOR||'var(--border)'}`,
                                        background:isSel?`${c.COLOR||'#2e6da4'}22`:'transparent',
                                        color:isSel?'#111':(c.COLOR||'var(--text3)'),fontWeight:isSel?700:400}}>
                                      {c.ETIQUETA}
                                    </button>
                                  );
                                })}
                              </div>
                            );
                          };

                          const renderArchivoUpload = (ordCod, det) => {
                            const tieneArchivo = !!det.ARCHIVO_RESULTADO;
                            return (
                              <div>
                                {det.LABORATORIO_EXT&&(
                                  <div style={{fontSize:9.5,color:'var(--amber)',marginBottom:5,display:'flex',alignItems:'center',gap:3}}>
                                    🏥 Enviado a {det.LABORATORIO_EXT}
                                  </div>
                                )}
                                <label style={{display:'flex',alignItems:'center',gap:8,padding:'10px 12px',
                                    border:`1.5px dashed ${tieneArchivo?'var(--green)':'var(--amber)'}`,borderRadius:8,cursor:'pointer',
                                    background:tieneArchivo?'var(--green-lt)':'var(--surface)'}}>
                                  <span style={{fontSize:16}}>{tieneArchivo?'✅':'📎'}</span>
                                  <div style={{flex:1,minWidth:0}}>
                                    <div style={{fontSize:11,fontWeight:500,color:tieneArchivo?'var(--green)':'var(--text)'}}>
                                      {tieneArchivo?'Archivo cargado':'Subir PDF del resultado externo'}
                                    </div>
                                    {tieneArchivo&&(
                                      <a href={`${process.env.REACT_APP_API_URL?.replace('/api','')||''}/uploads/laboratorio/${det.ARCHIVO_RESULTADO}`}
                                        target="_blank" rel="noreferrer" style={{fontSize:10,color:'var(--navy-lt)'}}
                                        onClick={e=>e.stopPropagation()}>Ver archivo actual ↗</a>
                                    )}
                                  </div>
                                  <input type="file" accept="application/pdf,image/*" style={{display:'none'}}
                                    onChange={e=>{ if(e.target.files[0]) subirArchivoResultado(ordCod, det.COD, e.target.files[0]); }}/>
                                </label>
                              </div>
                            );
                          };

                          const renderInput = (key, det) => {
                            const val = resultados[key]||'';
                            const tipoRes = det?.C_TIPO_RESULTADO || 'NUM';
                            if (tipoRes==='NUM') {
                              const est=evalR(val,det?.rango);
                              return(
                                <>
                                  <td><input className={'r-inp'+(val?' '+est:'')} value={val}
                                    onChange={e=>setResultados(r=>({...r,[key]:e.target.value}))} placeholder="—"/></td>
                                  <td style={{fontSize:10,color:'var(--text3)'}}>{det?.rango?.UNIDAD||'—'}</td>
                                  <td style={{fontSize:9,color:'var(--text3)'}}>
                                    {det?.rango?`${det.rango.LIMITE_INFERIOR>0?det.rango.LIMITE_INFERIOR:''} ${det.rango.LIMITE_INFERIOR>0&&det.rango.LIMITE_SUPERIOR>0?'–':''} ${det.rango.LIMITE_SUPERIOR>0?det.rango.LIMITE_SUPERIOR:''}`.trim()||'—':'—'}
                                  </td>
                                  <td>{val?<span className={'rb-'+est}>{est==='ok'?'✓ Normal':est==='hi'?'↑ Alto':'↓ Bajo'}</span>:<span className="rb-na">—</span>}</td>
                                </>
                              );
                            }
                            const tipoResLocal = det?.C_TIPO_RESULTADO || 'NUM';
                            if (tipoResLocal==='RNE') {
                              return(
                                <td colSpan={4}>
                                  <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                                    {['REACTIVO','NO REACTIVO','POSITIVO','NEGATIVO'].map(op=>(
                                      <button key={op} onClick={()=>setResultados(r=>({...r,[key]:op}))}
                                        style={{padding:'3px 10px',borderRadius:5,fontSize:10,cursor:'pointer',
                                          border:`1px solid ${val===op?'var(--navy)':'var(--border)'}`,
                                          background:val===op?'var(--navy)':'transparent',
                                          color:val===op?'#fff':'var(--text3)',fontWeight:val===op?600:400}}>
                                        {op}
                                      </button>
                                    ))}
                                  </div>
                                </td>
                              );
                            }
                            if (tipoResLocal==='TXT') {
                              return(
                                <td colSpan={4}>
                                  <textarea className="form-control" rows={2} style={{fontSize:11,resize:'vertical',width:'100%'}}
                                    value={val} onChange={e=>setResultados(r=>({...r,[key]:e.target.value}))}
                                    placeholder="Descripción del resultado..."/>
                                </td>
                              );
                            }
                            return <td colSpan={4}><span style={{fontSize:11,color:'var(--text3)'}}>—</span></td>;
                          };

                          return(
                            <div className="res-tbl-wrap">
                            <table className="res-tbl">
                              <thead><tr>
                                <th style={{width:'30%'}}>Determinación</th>
                                <th style={{width:'70%'}}>Resultado</th>
                              </tr></thead>
                              <tbody>
                                {rangosOrd.detalles.map(det=>{
                                  const hasSubs=det.subdeterminaciones?.length>0;
                                  return(
                                    <React.Fragment key={det.COD}>
                                      {!hasSubs&&(()=>{
                                        const tr = det.C_TIPO_RESULTADO||'NUM';
                                        const val = resultados[det.COD]||'';
                                        const est = tr==='NUM'?evalR(val,det.rango):'na';
                                        return(
                                          <tr className={tr==='NUM'&&val&&est!=='ok'?'alt-row':''}>
                                            <td style={{fontWeight:500}}>{det.DETERMINACION}</td>
                                            <td colSpan={1}>
                                              {det.ES_EXTERNO==='V'?renderArchivoUpload(ord.COD, det):(<>
                                              {tr==='NUM'&&(
                                                <div style={{display:'flex',gap:6,alignItems:'center',flexWrap:'wrap'}}>
                                                  <input className={'r-inp'+(val?' '+est:'')} value={val}
                                                    onChange={e=>setResultados(r=>({...r,[det.COD]:e.target.value}))} placeholder="—"
                                                    style={{width:88}}/>
                                                  <span style={{fontSize:10,color:'var(--text3)'}}>{det.rango?.UNIDAD||''}</span>
                                                  {det.rango&&<span style={{fontSize:9,color:'var(--text3)'}}>
                                                    {det.rango.LIMITE_INFERIOR>0?det.rango.LIMITE_INFERIOR:''}{det.rango.LIMITE_INFERIOR>0&&det.rango.LIMITE_SUPERIOR>0?' – ':''}{det.rango.LIMITE_SUPERIOR>0?det.rango.LIMITE_SUPERIOR:''}
                                                  </span>}
                                                  {val&&<span className={'rb-'+est}>{est==='ok'?'✓ Normal':est==='hi'?'↑ Alto':'↓ Bajo'}</span>}
                                                </div>
                                              )}
                                              {tr==='NUM'&&det.categorias?.length>0&&renderCategoriaChain(val, det.categorias)}
                                              {det.texto_referencia&&(
                                                <div style={{fontSize:9,color:'var(--text3)',marginTop:3,whiteSpace:'pre-line',lineHeight:1.4}}>
                                                  📋 {det.texto_referencia}
                                                </div>
                                              )}
                                              {tr==='RNE'&&(
                                                <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
                                                  {['REACTIVO','NO REACTIVO','POSITIVO','NEGATIVO'].map(op=>(
                                                    <button key={op} onClick={()=>setResultados(r=>({...r,[det.COD]:op}))}
                                                      style={{padding:'3px 10px',borderRadius:5,fontSize:10,cursor:'pointer',
                                                        border:`1px solid ${val===op?'var(--navy)':'var(--border)'}`,
                                                        background:val===op?'var(--navy)':'transparent',
                                                        color:val===op?'#fff':'var(--text3)',fontWeight:val===op?600:400}}>
                                                      {op}
                                                    </button>
                                                  ))}
                                                  {val&&<span style={{fontSize:10,fontWeight:600,color:'var(--navy)',marginLeft:4}}>{val}</span>}
                                                </div>
                                              )}
                                              {tr==='OPC'&&renderOpcionesPills(det.COD, val, det.categorias)}
                                              {(tr==='TXT'||tr==='PDF')&&(
                                                <textarea className="form-control" rows={2}
                                                  style={{fontSize:11,resize:'vertical',width:'100%'}}
                                                  value={val} onChange={e=>setResultados(r=>({...r,[det.COD]:e.target.value}))}
                                                  placeholder={tr==='PDF'?'Descripción del resultado externo...':'Descripción del resultado...'}/>
                                              )}
                                              </>)}
                                            </td>
                                          </tr>
                                        );
                                      })()}
                                      {hasSubs&&(()=>{
                                        const tr2 = det.C_TIPO_RESULTADO||'NUM';
                                        if (tr2==='TXT'||tr2==='PDF') {
                                          const groups=[];
                                          det.subdeterminaciones.forEach(sub=>{
                                            const sec=sub.SECCION||'';
                                            let g=groups.find(g=>g.sec===sec);
                                            if(!g){g={sec,items:[]};groups.push(g);}
                                            g.items.push(sub);
                                          });
                                          return (
                                            <tr>
                                              <td colSpan={2} style={{padding:0}}>
                                                <div style={{padding:'10px 14px'}}>
                                                  <div className="res-sub-sep" style={{margin:'-10px -14px 10px',padding:'4px 14px'}}>{det.DETERMINACION}</div>
                                                  {groups.map((g,gi)=>(
                                                    <div key={gi} style={{marginBottom:gi<groups.length-1?12:0}}>
                                                      {g.sec&&<div style={{fontSize:9,fontWeight:600,color:'var(--text3)',textTransform:'uppercase',letterSpacing:'.3px',borderBottom:'0.5px solid var(--border)',paddingBottom:3,marginBottom:6}}>{g.sec}</div>}
                                                      <div className="subdet-grid">
                                                        {g.items.map(sub=>{
                                                          const key=`${det.COD}_${sub.COD}`;
                                                          const val2=resultados[key]||'';
                                                          return (
                                                            <div key={sub.COD}>
                                                              <div style={{fontSize:9.5,color:'var(--text3)',marginBottom:2,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{sub.SUBDETERMINACION}</div>
                                                              <input className="r-inp" style={{width:'100%',fontSize:11}} value={val2}
                                                                onChange={e=>setResultados(r=>({...r,[key]:e.target.value}))} placeholder="—"/>
                                                            </div>
                                                          );
                                                        })}
                                                      </div>
                                                    </div>
                                                  ))}
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                        return (
                                          <>
                                            <tr><td colSpan={2} className="res-sub-sep">{det.DETERMINACION}</td></tr>
                                            {det.subdeterminaciones.map(sub=>{
                                              const key=`${det.COD}_${sub.COD}`;
                                              const val2 = resultados[key]||'';
                                              const est2 = tr2==='NUM'?evalR(val2,sub.rango):'na';
                                              return(
                                                <tr key={sub.COD} className={tr2==='NUM'&&val2&&est2!=='ok'?'alt-row':''}>
                                                  <td style={{paddingLeft:16}}>{sub.SUBDETERMINACION}</td>
                                                  <td>
                                                    {tr2==='NUM'&&(
                                                      <div style={{display:'flex',gap:6,alignItems:'center',flexWrap:'wrap'}}>
                                                        <input className={'r-inp'+(val2?' '+est2:'')} value={val2}
                                                          onChange={e=>setResultados(r=>({...r,[key]:e.target.value}))} placeholder="—" style={{width:88}}/>
                                                        <span style={{fontSize:10,color:'var(--text3)'}}>{sub.rango?.UNIDAD||''}</span>
                                                        {val2&&<span className={'rb-'+est2}>{est2==='ok'?'✓ Normal':est2==='hi'?'↑ Alto':'↓ Bajo'}</span>}
                                                      </div>
                                                    )}
                                                    {tr2==='RNE'&&(
                                                      <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
                                                        {['REACTIVO','NO REACTIVO','POSITIVO','NEGATIVO'].map(op=>(
                                                          <button key={op} onClick={()=>setResultados(r=>({...r,[key]:op}))}
                                                            style={{padding:'3px 10px',borderRadius:5,fontSize:10,cursor:'pointer',
                                                              border:`1px solid ${val2===op?'var(--navy)':'var(--border)'}`,
                                                              background:val2===op?'var(--navy)':'transparent',
                                                              color:val2===op?'#fff':'var(--text3)'}}>
                                                            {op}
                                                          </button>
                                                        ))}
                                                      </div>
                                                    )}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </>
                                        );
                                      })()}
                                    </React.Fragment>
                                  );
                                })}
                              </tbody>
                            </table>
                            </div>
                          );
                        })()}
                      </div>

                      {/* PASO 4: Observaciones */}
                      <div style={{borderBottom:'1px solid var(--border)',padding:12}}>
                        <div style={{background:'var(--navy)',padding:'5px 12px',display:'flex',alignItems:'center',gap:7,margin:'-12px -12px 10px'}}>
                          <div style={{width:18,height:18,borderRadius:'50%',background:'rgba(255,255,255,.25)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:700}}>4</div>
                          <span style={{fontSize:10,fontWeight:600,color:'#fff'}}>Observaciones</span>
                        </div>
                        <div style={{display:'flex',flexDirection:'column',gap:8}}>
                          {[['recibo','Obs. recibo de muestras'],['laboratorista','Obs. laboratorista'],['resultados_obs','Obs. resultados (visible al paciente)']].map(([k,lbl])=>(
                            <div key={k}>
                              <div style={{fontSize:10,color:'var(--text3)',marginBottom:3}}>{lbl}</div>
                              <textarea className="form-control" rows={2} style={{fontSize:11,resize:'vertical'}}
                                value={obsOrd[k]||''} onChange={e=>setObsOrd(o=>({...o,[k]:e.target.value}))}
                                placeholder={lbl+'...'}/>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Footer */}
                      <div style={{padding:'10px 14px',display:'flex',justifyContent:'flex-end',gap:8,background:'var(--surface2)',flexWrap:'wrap'}}>
                        <div style={{flex:1,fontSize:10,color:'var(--text3)',alignSelf:'center'}}>
                          {Object.keys(resultados).length} resultado(s) ingresado(s)
                        </div>
                        <button className="btn btn-sm" disabled={savingOrd} onClick={()=>guardarBorradorOrd(ord.COD)}>💾 Borrador</button>
                        <button className="btn btn-sm" onClick={()=>descargarPDF(ord.COD)}>🖨️ PDF pedido</button>
                        {ord.C_ESTADO==='CNF'&&<button className="btn btn-sm" style={{background:'var(--blue-lt)',color:'var(--navy)',border:'1px solid var(--navy-lt)'}} onClick={()=>descargarInforme(ord.COD)}>📋 Informe resultados</button>}
                        <button className="btn btn-primary" disabled={savingOrd||!Object.keys(resultados).length}
                          onClick={()=>validarOrden(ord.COD)}>
                          {savingOrd?'Validando...':'✓ Validar y generar portal'}
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* ── Archivos del paciente ── */}
          {tab==='arch' && (
            <div style={{padding:14}}>
              {!paciente && <div style={{padding:24,textAlign:'center',color:'var(--text3)'}}>Selecciona un paciente</div>}
              {paciente && (<>
                <div style={{marginBottom:10}}>
                  <input className="form-control" placeholder="Descripción del archivo (opcional)"
                    value={descArch} onChange={e=>setDescArch(e.target.value)} style={{fontSize:12}}/>
                </div>
                <div className={`drop-zone ${dragging?'over':''}`}
                  onDragOver={e=>{e.preventDefault();setDragging(true)}}
                  onDragLeave={()=>setDragging(false)}
                  onDrop={e=>{e.preventDefault();setDragging(false);
                    [...e.dataTransfer.files].forEach(f=>subirArchivo(f));}}
                  onClick={()=>fileRef.current?.click()}>
                  <div className="icon">📁</div>
                  <div style={{fontSize:13,fontWeight:500}}>Arrastra archivos aquí o haz clic</div>
                  <div style={{fontSize:11,color:'var(--text3)',marginTop:4}}>PDF, JPG, PNG — hasta 20MB</div>
                  <input ref={fileRef} type="file" accept=".pdf,.jpg,.jpeg,.png" multiple
                    style={{display:'none'}}
                    onChange={e=>[...e.target.files].forEach(f=>subirArchivo(f))}/>
                </div>
                {archivos.length > 0 && (
                  <div style={{marginTop:12,display:'flex',flexDirection:'column',gap:6}}>
                    {archivos.map((a,i)=>(
                      <div key={a.COD||i} style={{display:'flex',alignItems:'center',gap:8,padding:'6px 10px',
                        background:'var(--surface)',borderRadius:6,fontSize:12}}>
                        <span>📄</span>
                        <span style={{flex:1}}>{a.nombre}</span>
                        {a.url && <a href={a.url} target="_blank" rel="noreferrer"
                          style={{color:'var(--navy-lt)',fontSize:11}}>Ver</a>}
                        <span style={{fontSize:10,color:'var(--text3)'}}>
                          {a.fecha ? new Date(a.fecha).toLocaleDateString('es-EC') : ''}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </>)}
            </div>
          )}
        </div>
      </div>

      {editando && (() => {
        const todasCategorias = [...tiposLab, ...tiposImg];
        return (
          <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',display:'flex',
            alignItems:'center',justifyContent:'center',zIndex:1000}}
            onClick={e=>e.target===e.currentTarget && setEditando(null)}>
            <div style={{background:'#fff',borderRadius:10,width:'90%',maxWidth:640,maxHeight:'85vh',
              display:'flex',flexDirection:'column',overflow:'hidden'}}>
              <div style={{background:'var(--navy)',color:'#fff',padding:'12px 16px',
                display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <span style={{fontWeight:700}}>Editar pedido — {editando.TIPO_DETERMINACION}</span>
                <span style={{cursor:'pointer',fontSize:18}} onClick={()=>setEditando(null)}>&#x2715;</span>
              </div>
              <div style={{padding:16,overflowY:'auto',flex:1}}>
                <label className="form-label" style={{fontSize:11}}>Datos clínicos</label>
                <textarea className="form-control" rows={2} style={{marginBottom:14}}
                  value={observEdit} onChange={e=>setObservEdit(e.target.value)} />

                <label className="form-label" style={{fontSize:11}}>
                  Exámenes del pedido ({selIdsEdit.length} seleccionados)
                </label>
                <div style={{fontSize:10,color:'var(--text3)',marginBottom:8}}>
                  Podés agregar exámenes de cualquier categoría, no solo la original.
                </div>
                <div style={{display:'flex',flexDirection:'column',gap:6,marginTop:6}}>
                  {todasCategorias.map(cat => {
                    const marcados = (cat.determinaciones||[]).filter(d=>selIdsEdit.includes(d.COD)).length;
                    return (
                      <details key={cat.COD} open={cat.COD===editando.COD_TIPO_EXAMEN || marcados>0}>
                        <summary style={{cursor:'pointer',fontSize:12,fontWeight:600,padding:'6px 4px'}}>
                          {cat.TIPO_DETERMINACION} {marcados>0 && <span style={{color:'var(--navy)'}}>({marcados})</span>}
                        </summary>
                        <div style={{display:'flex',flexDirection:'column',gap:3,paddingLeft:10,marginTop:4}}>
                          {(cat.determinaciones||[]).map(d => (
                            <label key={d.COD} className="det-item">
                              <input type="checkbox" checked={selIdsEdit.includes(d.COD)}
                                onChange={()=>toggleDetEdit(d.COD)}/>
                              {d.DETERMINACION}
                            </label>
                          ))}
                        </div>
                      </details>
                    );
                  })}
                </div>
              </div>
              <div style={{padding:'12px 16px',borderTop:'1px solid var(--border)',
                display:'flex',justifyContent:'flex-end',gap:8}}>
                <button className="btn btn-sm" onClick={()=>setEditando(null)}>Cancelar</button>
                <button className="btn btn-sm" style={{background:'var(--navy)',color:'#fff',border:'none'}}
                  disabled={savingEdit} onClick={guardarEdicion}>
                  {savingEdit ? 'Guardando...' : 'Guardar cambios'}
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </>
  );
}
